var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import * as Flags from 'country-flag-icons/react/3x2';
import { hasFlag } from 'country-flag-icons';
import AN from '../../public/images/flag_netherlands_antilles.png';
var FlagIcon = function (_a) {
    var _b = _a.code, code = _b === void 0 ? '' : _b;
    var upperCode = code.toUpperCase();
    // @ts-ignore
    var Flag = hasFlag(upperCode) ? Flags[upperCode] : CustomFlag;
    return _jsx(FlagWrapper, { as: Flag, className: "flag-icon-" + upperCode }, void 0);
};
export default FlagIcon;
var FlagWrapper = styled.svg(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  vertical-align: middle;\n  margin-right: 10px;\n  flex-shrink: 0;\n  width: 18px;\n  height: 17px;\n"], ["\n  vertical-align: middle;\n  margin-right: 10px;\n  flex-shrink: 0;\n  width: 18px;\n  height: 17px;\n"])));
var CustomFlag = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  &.flag-icon-AN {\n    background: url(", ") no-repeat center;\n    background-size: cover;\n  }\n"], ["\n  &.flag-icon-AN {\n    background: url(", ") no-repeat center;\n    background-size: cover;\n  }\n"])), AN);
var templateObject_1, templateObject_2;
